import React, { Component } from 'react';
import { Col, Form, Input, List, Modal, Row } from 'antd';
import DatePicker from 'react-modern-calendar-datepicker';
import moment from "moment-jalaali";
import { Constants } from '../scripts/settings';
import API from '../scripts/api';
import Resources from '../scripts/resources';
import Rules from '../scripts/rules';

class ReportView extends Component {
    constructor() {
        super();

        this.state = {
            data: {}
        };

        this.formRef = React.createRef();
    }

    handleDate = (date, obj) => {
        const state = {};
        state[obj] = date;
        this.formRef.current.setFieldsValue(state);
    }

    handleCancel = () => {
        this.formRef.current.resetFields();
        this.props.onCancel();
    }

    handleSubmit = () => {
        this.formRef.current.validateFields().then(values => {
            const { fromDate, toDate } = values;
            const data = { id: this.props.data.id };

            if (fromDate)
                data.fromDate = moment(`${fromDate.year}-${fromDate.month}-${fromDate.day}`, Constants.jDateFormat).format(Constants.dateFormat);

            if (toDate)
                data.toDate = moment(`${toDate.year}-${toDate.month}-${toDate.day}`, Constants.jDateFormat).format(Constants.dateFormat);

            this.setState({ submitting: true });

            API.postman.report(data)
                .then((result) => {
                    this.setState({ data: result, loaded: true, submitting: false });
                })
                .catch(() => {
                    this.setState({ submitting: false });
                });
        });
    }

    render() {
        const { visible } = this.props;
        const { data, loaded, submitting } = this.state;

        const DatePickerInput = ({ ref }, name) => {
            const date = this.formRef.current ? this.formRef.current.getFieldValue(name) : null;
            return <Input value={date ? `${date.year}-${date.month}-${date.day}` : date} placeholder={Resources.choose} ref={ref} readOnly />;
        };

        return (
            <Modal
                title={Resources.report}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.handleCancel}
                okText={Resources.confirm}
                cancelText={Resources.cancel}
                okButtonProps={{ loading: submitting }}
                cancelButtonProps={{ disabled: submitting }}
                width={700}>
                <Form ref={this.formRef} layout="vertical">
                    <Row gutter={24}>
                        <Col xs={24} md={12}>
                            <Form.Item name="fromDate" label={Resources.fromDate} rules={Rules.required}>
                                <DatePicker
                                    locale="fa"
                                    onChange={value => this.handleDate(value, 'fromDate')}
                                    renderInput={(ref) => DatePickerInput(ref, 'fromDate')}
                                    shouldHighlightWeekends
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item name="toDate" label={Resources.toDate} rules={Rules.required}>
                                <DatePicker
                                    locale="fa"
                                    onChange={value => this.handleDate(value, 'toDate')}
                                    renderInput={(ref) => DatePickerInput(ref, 'toDate')}
                                    shouldHighlightWeekends
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                {loaded && <List>
                    <List.Item>
                        <List.Item.Meta title={Resources.sumDelivery} description={data.sumDelivery || '0'} />
                    </List.Item>
                    <List.Item>
                        <List.Item.Meta title={Resources.countPredictedDistance} description={data.countPredictedDistance || '0'} />
                    </List.Item>
                </List>}
            </Modal>
        );
    }
};

export default ReportView;